import { navigate, repoPath, useCurrentRepo } from "./router";

// AdrLink turns an ADR id into a link to its reader page, everywhere an ADR
// is mentioned in structured data across this app (linked/related ADRs,
// dashboard ADR coverage). Only resolved references — a non-empty title —
// are linked; an unresolved reference (empty title, the existing
// "(unresolved reference)" convention) stays plain text, since linking a
// reference that never matched a parsed ADR would just land on a 404.
// repo defaults to the current URL's repo (every real caller renders inside
// a page already scoped to one repo) — an explicit override exists only for
// the rare case of linking to an ADR known to live in a different repo.
export function AdrLink({ id, title, repo }: { id: string; title?: string; repo?: string }) {
  const currentRepo = useCurrentRepo();
  const targetRepo = repo ?? currentRepo;
  if (title === "") return <span className="mono">{id}</span>;
  const path = repoPath(targetRepo, "adrs", id);
  return (
    <a
      className="mono"
      href={path}
      onClick={(e) => {
        e.preventDefault();
        navigate(path);
      }}
    >
      {id}
    </a>
  );
}
